/*
Item: Export Dialog component for exporting tables from Statistics.jsx
Name: ExportDialog
Format: Code/Frontend component
*/
import React, { Component } from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { MultiSelect } from 'primereact/multiselect';

const DialogType = Object.freeze({
  none: 0,
  releaseToAll: 1,
  releaseGroup: 2,
});

const items = {
  years: [
    { label: '2018', value: '18' },
    { label: '2019', value: '19' },
    { label: '2020', value: '20' },
  ],
  semesters: [
    { label: 'SS 2018', value: 'SS18' },
    { label: 'WS 2018/2019', value: 'WS18' },
    { label: 'SS 2019', value: 'SS19' },
    { label: 'WS 2019/2020', value: 'WS19' },
    { label: 'SS 2020', value: 'SS20' },
  ],
  locs: [
    { label: 'Bund', value: 'Bund' },
    { label: 'Baden-Württemberg', value: 'BW' },
    { label: 'Bayern', value: 'BY' },
    { label: 'Berlin', value: 'BE' },
    { label: 'Brandenburg', value: 'BB' },
    { label: 'Bremen', value: 'HB' },
    { label: 'Hamburg', value: 'HH' },
    { label: 'Hessen', value: 'HE' },
    { label: 'Mecklenburg-Vorpommern', value: 'MV' },
    { label: 'Niedersachsen', value: 'NI' },
    { label: 'Nordrhein-Westfalen', value: 'NW' },
    { label: 'Rheinland-Pfalz', value: 'RP' },
    { label: 'Saarland', value: 'SL' },
    { label: 'Sachsen', value: 'SN' },
    { label: 'Sachsen-Anhalt', value: 'ST' },
    { label: 'Thüringen', value: 'TH' },
  ],
};

export default class StandardFoldersDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      year: undefined,
      semester: undefined,
      loc: undefined,
    };
  }

  returnDropdowns() {
    if (this.props.selectedCategory === 'Standardtabelle') {
      return (
        <div className="card">
          <div className="p-grid p-fluid">
            <div className="p-col-12 p-lg-12">
              <div className="p-col-12 p-lg-12">
                <Dropdown
                  value={this.state.year}
                  options={items.years}
                  onChange={(e) => {
                    this.setState({ year: e.value });
                  }}
                  placeholder="Berichtsjahr..."
                />
                <br />
                <p />
              </div>
              <div className="p-col-12 p-lg-12">
                <Dropdown
                  value={this.state.semester}
                  options={items.semesters}
                  onChange={(e) => {
                    this.setState({ semester: e.value });
                  }}
                  placeholder="Berichtssemester..."
                />
                <br />
                <p />
              </div>
              <div className="p-col-12 p-lg-12">
                <MultiSelect
                  value={this.state.loc}
                  options={items.locs}
                  onChange={(e) => {
                    this.setState({ loc: e.value });
                  }}
                  placeholder="Regionalauswahl..."
                />
              </div>
            </div>
          </div>
        </div>
      );
    }
    return (
      <div className="card">
        <div className="p-grid p-fluid">
          <div className="p-col-12 p-lg-12">
            <div className="p-col-12 p-lg-12">
              <Dropdown
                value={this.state.loc}
                options={items.locs}
                onChange={(e) => {
                  this.setState({ loc: e.value });
                }}
                placeholder="Regionalauswahl..."
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderFooter() {
    const { onHide, handleYes } = this.props;
    return (
      <div>
        <Button id="continue" label="Weiter" icon="pi pi-check" onClick={() => handleYes()} />
        <Button
          id="cancel"
          label="Abbruch"
          className="p-button-danger"
          icon="pi pi-times"
          onClick={() => onHide()}
        />
      </div>
    );
  }

  render() {
    const { selectedCategory, visible, onHide } = this.props;
    return (
      <Dialog
        header={selectedCategory}
        visible={visible}
        style={{ width: '40vw' }}
        footer={this.renderFooter()}
        onHide={() => onHide()}
        modal
      >
        {this.returnDropdowns()}
      </Dialog>
    );
  }
}
